import * as api from "../../api";
import { playSound } from "@/utils/soundUtils.js";
import { getStableFakeName } from "@/utils/fakeName.js";

export const getActiveOrders = (immediate = false) => {
  return async (dispatch, getState) => {
    const currentTime = new Date().getTime();
    if (!immediate) {
      if (window.activeOrdersFetchTimer) {
        return;
      }
      const lastFetchTime = window.lastActiveOrdersFetchTime || 0;
      if (currentTime - lastFetchTime < 2000) {
        window.activeOrdersFetchTimer = setTimeout(() => {
          clearTimeout(window.activeOrdersFetchTimer);
          window.activeOrdersFetchTimer = null;
          dispatch(getActiveOrders());
        }, 2000);
        return;
      }
    }
    clearTimeout(window.activeOrdersFetchTimer);
    window.activeOrdersFetchTimer = null;
    window.lastActiveOrdersFetchTime = currentTime;
    const result = await api.getActiveOrders();
    let orders = result?.orders || [];
    dispatch({ type: "LOAD_ACTIVE_ORDERS", payload: orders });
    if(immediate){
      dispatch({ type: "SET_LAST_UPDATED" });
    }
    const activeOrdersInitLoaded = getState().orders.activeOrdersInitLoad;
    const isDemoUser = getState().app.isDemoUser;
    if(isDemoUser){
      orders = orders.map(order => {
        const { first_name, last_name } = getStableFakeName(order._id, !order.direct);
        order.customer.first_name = first_name;
        order.customer.last_name = last_name;
        return order;
      });
    }

    const seenOrders = getState().orders.seenOrders;
    const newOrders = orders.filter(
      (order) => !seenOrders.includes(order._id) && (order.order_status <= 0 || order.order_status === 11)
    );
    if (newOrders.length > 0) {
      dispatch({
        type: "ADD_SEEN_ORDERS",
        payload: newOrders.map((order) => order._id),
      });
      dispatch({ type: "ADD_UNSEEN_ORDER_COUNT", payload: newOrders.length });
      let pushToken = localStorage.getItem('push_token');
      if (activeOrdersInitLoaded && !pushToken) {
        const sound = localStorage.getItem('notification_sound');
        playSound(sound || "Gentle Ping.mp3");        
      }
    }

    dispatch({ type: "SET_ACTIVE_ORDERS_INIT_LOAD", payload: true });
  };
};
